/**
 * 协议路由
 */

export default [
  {
    path: '/agr/risk-warning',
    meta: {
      title: '风险提示书',
    },
    component: (resolve) => {
      require(['$views/agr/risk-warning.vue'], resolve)
    }
  },
  {
    path: '/agr/bindIdentity',
    meta: {
      title: '实名认证服务协议',
    },
    component: (resolve) => {
      require(['$views/agr/bindIdentity.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes/modules/agr.js